/**
 * Validates that a string matches UUID format
 */
export function validateUUID(id: string): boolean {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return uuidRegex.test(id)
}

/**
 * Validates that a string matches ISO date format (YYYY-MM-DD)
 */
export function validateISODateFormat(date: string): boolean {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  return dateRegex.test(date)
}

/**
 * Validates that a string matches time format (HH:mm)
 */
export function validateTimeFormat(time: string): boolean {
  const timeRegex = /^\d{2}:\d{2}$/
  return timeRegex.test(time)
}

/**
 * Parses a comma-separated string of IDs into an array of trimmed strings
 */
export function parseCommaSeparatedIds(idsStr: string): string[] {
  return idsStr
    .split(',')
    .map((id) => id.trim())
    .filter((id) => id)
}
